import { api } from "../api/api";

const errorHandler = (error) => {
  if (error?.code?.trim() === "ERR_NETWORK") {
    throw new Error(
      "It looks like we can't reach the server right now. Please try refreshing the page or check after sometime."
    );
  } else {
    throw new Error(error?.response?.data?.title);
  }
};

export const switchOrderFlow = async (payload) => {
  try {
    const response = await api.put(`api/SalesOrderAutomationConfigurations/${payload?.id}/Automate/${!payload?.isAutomated}`);
    return response.data?.result?.result || [];
  } catch (error) {
    errorHandler(error);
  }
};

export const getOrderConfigDetails = async (params) => {
  try {
    const response = await api.get(`api/SalesOrderAutomationConfigurations`, { params });
    return response.data?.result?.result || [];
  } catch (error) {
    errorHandler(error);
  }
};

//Fetch Trading Partner and Region List
export const getOrderConfigTradingPartnerDetails = async () => {
  try {
    const response = await api.get(`api/SalesOrderAutomationConfigurations/TradingPartnerRegions`);
    return response.data?.result?.result || [];
  } catch (error) {
    errorHandler(error);
  }
};